import React from 'react';

export function EntityModalPlaceholder() {
  return (
    <div className="entity-placeholder">
      <div className="animated-background">
        <div className="background-masker entity-avatar" />
        <div className="background-masker title-bottom" />
      </div>
    </div>
  );
}
